/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmConversationsCreateItems } from "../../funcs/llmConversationsCreateItems.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ConversationsItemsCreateRequest$inboundSchema,
};

export const tool$llmConversationsCreateItems: ToolDefinition<typeof args> = {
  name: "llm-conversations-create-items",
  description: `Create conversation items

Create items in a conversation with the given ID.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmConversationsCreateItems(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
